// src/features/privateAlbum/types/privateAlbumTypes.js

export const ALBUM_STATUS = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  DELETED: "deleted",
};

export const ACCESS_ROLE = {
  VIEWER: "viewer",
  COMMENTER: "commenter",
  DOWNLOADER: "downloader",
  UPLOADER: "uploader",
};

export const ACCESS_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REVOKED: "revoked",
  EXPIRED: "expired",
};

export const ACTION_TYPES = {
  VIEW: "view",
  DOWNLOAD: "download",
  COMMENT: "comment",
  SHARE: "share",
};

export const EVENT_TYPES = [
  { value: "wedding", label: "Wedding" },
  { value: "birthday", label: "Birthday" },
  { value: "engagement", label: "Engagement" },
  { value: "maternity", label: "Maternity" },
  { value: "corporate", label: "Corporate Event" },
  { value: "portrait", label: "Portrait Session" },
  { value: "event", label: "Event" },
  { value: "other", label: "Other" },
];

export const ROLE_LABELS = {
  viewer: "View Only",
  commenter: "Can Comment",
  downloader: "Can Download",
  uploader: "Can Upload",
};

export const ROLE_OPTIONS = [
  { value: "viewer", label: "View Only" },
  { value: "commenter", label: "Can Comment" },
  { value: "downloader", label: "Can Download" },
  { value: "uploader", label: "Can Upload" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
  { value: "deleted", label: "Deleted" },
];

// Error Messages
export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch albums. Please try again.",
  FETCH_ONE_FAILED: "Failed to fetch album details.",
  CREATE_FAILED: "Failed to create album. Please try again.",
  UPDATE_FAILED: "Failed to update album. Please try again.",
  DELETE_FAILED: "Failed to delete album. Please try again.",
  UPLOAD_FAILED: "Failed to upload photos. Please try again.",
  SHARE_FAILED: "Failed to share album. Please try again.",
  ACCESS_DENIED: "You do not have access to this album.",
  EMAIL_NOT_FOUND: "Email not found. Please enter a valid email.",
  EMAIL_ALREADY_SHARED: "This email already has access to this album.",
  EXPIRY_DATE_PAST: "Expiry date must be in the future.",
  INVALID_ROLE: "Invalid role specified.",
  PHOTO_NOT_FOUND: "Photo not found.",
  REVOKE_FAILED: "Failed to revoke access.",
  PHOTO_DELETE_FAILED: "Failed to delete photo.",
};

export const SUCCESS_MESSAGES = {
  CREATE_SUCCESS: "Album created successfully!",
  UPDATE_SUCCESS: "Album updated successfully!",
  DELETE_SUCCESS: "Album deleted successfully!",
  SHARE_SUCCESS: "Album shared successfully!",
  UPLOAD_SUCCESS: "Photos uploaded successfully!",
  ACCESS_REVOKED: "Access revoked successfully!",
  PHOTO_DELETED: "Photo deleted successfully!",
};
